const columnsAllWorkShift = [
  {
    title: "Index",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    align: "center",
    width: 50,
    fixed: "left",
  },
  {
    title: "Code",
    key: "code",
    dataIndex: "code",
    sorter: (a, b) => a.code.localeCompare(b.code),
    fixed: "left",
    width: 100,
  },
  {
    title: "Title",
    key: "title",
    dataIndex: "title",
    sorter: (a, b) => a.title.localeCompare(b.title),
    width: 250,
  },
  {
    title: "Start Time",
    dataIndex: "startTime",
    key: "startTime",
    scopedSlots: { customRender: "startTime" },
  },
  {
    title: "End Time",
    dataIndex: "endTime",
    key: "endTime",
    scopedSlots: { customRender: "endTime" },
  },
  {
    title: "Duration",
    dataIndex: "duration",
    key: "duration",
  },
  // {
  //   title: "Số công",
  //   dataIndex: "coefficient",
  //   key: "coefficient",
  // },
  {
    title: "Overtime",
    key: "isOvertime",
    dataIndex: "isOvertime",
    scopedSlots: { customRender: "isOvertime" },
    align: "center",
  },
  // {
  //   title: "Tạo bởi",
  //   key: "author",
  //   scopedSlots: { customRender: "author" },
  // },
  {
    title: "Created At",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Updated At",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    fixed: "right",
  },
];

export { columnsAllWorkShift };
